// Culture list
export const ADHOCRACY = {letter: "A",
    name: "Adhocracy",
    description: "Dynamic, entrepreneurial create culture",
    breakdown: ["Usually defined as flexible, doesn't take on normal procedures or policies",
                "Always forward thinking, what can we do to make this better? Can we do something a new way?",
                "Fast paced",
                "Titles aren't everything, ideas/challenges can come from anyone and anywhere",
                "Promotes outside of the box thinking"],
}

export const HIERARCHY = {letter: "H", name: "Hierarchy", description: "Process-oriented, structured control culture",
    breakdown: ["Very \"by the book\" on majority of decisions/things in the business",
                "Chain of command is heavily relied on",
                "Needing to do the right thing, meet responsibilities and metrics, follow the rules",
                "Very limited grey area, things are clearly defined"],
}

export const COMMUNITY = {letter: "C", name: "Community", description: "People oriented, friendly collaborative culture", breakdown: ["Community oriented, common interest/common goals",
"Usually tends to lean towards small organizations",
"Employees valued more so on relationships/communication rather than status or experience",
"Employee first mindset, extremely supportive organization",
"Most work done in teams as it creates equality within work"],
}

export const MARKET = {letter: "M", name: "Market", description: "Results-oriented, competitive driven culture", breakdown: ["Competitive on all levels",
"Results driven and typically with an external focus (customers, clients)",
"Demand based service or product",
"Does have a creative side as well, new ideas or improvements to stay in the race with competitors",
"Incentivized work"],
}

// Persona List
export const PIONEER = {name: "Pioneer", description: ["Ready and eager to impact the world",
                                     "Dominant personality with hyper focus",
                                     "Not afraid to challenge the status quo",
                                     "Indifferent to whether they are liked",
                                     "Highly individualistic and reluctant to rely on others",
                                     "Fears losing control or being insignificant",
                                     "Hyper focus can lead to ignoring relationships or responsibilities"], 
                                     id: "e74d70a1-26b6-4495-2f86-a2a92179dc08", 
                                     tagId: "b00962b9-9576-4d3e-3e96-9e1e7781dc08"}

export const ADVOCATE = {name: "Advocate", description: ["High mission orientation and eagerness to make the world better",
                                   "Pulls people together, the consummate party planner",
                                   "Energized by working with others toward a common goal",
                                   "Views themselves as one of the group trying to change the world",
                                   "Very opinionated and can be viewed as an idealist",
                                   "May struggle to connect with others that don't share their views",
                                   "Likely polarizing which makes collaboration or persuasion difficult",
                                   "Obsession with their views may lead to isolation and exclusion"], 
                                   id: "8868524d-47de-415b-ce9e-feb92179dc08", 
                                   tagId: "d7315eaa-a4d8-4f01-f9c2-991e7781dc08"}

export const ENTREPRENEUR = {name: "Entrepreneur", description: ["Rules are helpful to identify loopholes",
                                     "Hyper-aware of public perception",
                                     "Methodical and strategic mindset to achieve goals",
                                     "High energy and fiercely competitive",
                                     "Self-promoters who feel comfortable in the spotlight",
                                     "Fears failing or the perception that they cannot handle something",
                                     "Risk of comparison to others creating envy or self-doubt"], 
                                     id: "41712224-e327-4828-f123-fcb92179dc08", 
                                     tagId: "fadaed31-87db-4a78-f9c2-991e7781dc08"}

export const NAVIGATOR = {name: "Navigator", description: ["Do it yourself mindset, out to change the way the game is played",
                                 "Detailed and process-oriented but driven by a need to make an impact",
                                 "Willing to bet on themselves within their area of expertise",
                                 "Likes being in charge and believes in a chain of command",
                                 "High personal standard can create difficulty relating to others",
                                 "Fears not being able to be in control"], 
                                 id: "e09f7891-10f8-47ef-f123-fcb92179dc08", 
                                 tagId: "07a495af-fec5-4b89-f9c2-991e7781dc08"}

export const DIPLOMAT = {name: "Diplomat", description: ["Not afraid to challenge the status quo if its beneficial",
                                      "High mission orientation and eagerness to make the world better",
                                      "Hyper-aware of public perception, fears not being accepted",
                                      "Self-promoters who tend to seek the spotlight",
                                      "Likes being in charge and believes in a chain of command",
                                      "Willing to bet on themselves within their area of expertise"], 
                                      id: "5f3809eb-f950-4463-ad25-11c32179dc08", 
                                      tagId: "95205ade-e0ed-47ba-f9c2-991e7781dc08"}


export const GENERAL = {name: "General", description: ["Believes experience is crucial to knowing what to do next",
                                 "Prefers to be of service rather than in control",
                                 "Rule follower believes in doing the right thing always",
                                 "Extremely detail oriented and accomplishment focused",
                                 "Mission orientation but practical about the impact they can make",
                                 "Fears their ambition and drive to succeed being seen as ego"], 
                                 id: "2523b60b-5f61-43ce-5dee-2ede2179dc08", 
                                 tagId: "80e5397e-75a7-40bc-f9c2-991e7781dc08"}

export const GUARDIAN = {name: "Guardian", description: ["Cares deeply about others and seeks to provide support",
                                 "Great at aiding and onboarding new colleagues",
                                 "Prefers to blend in rather than stand out for their work",
                                 "Fears being isolated or underappreciated",
                                 "High empathy manifests in an outward kindness and warmth",
                                 "Go-to for advice and support for friends and colleagues"], 
                                 id: "c57e250c-a521-4185-5dee-2ede2179dc08", 
                                 tagId: "a99854c0-ab64-47a0-f9c2-991e7781dc08"}

export const CLOSER = {name: "Closer", description: ["Loves a list of tasks they can crush",
                               "Not afraid to do the dirty work or be the villain",
                               "Likes to be recognized for their performance and respected for contribution",
                               "Desires knowledge and is likely to pursue expert status over leadership",
                               "Natural skepticism can present as a preoccupation with what could go wrong",
                               "Fears being unprepared when called upon to perform"], 
                               id: "af703597-c950-4b34-5dee-2ede2179dc08", 
                               tagId: "c5b3e055-f456-456b-f9c2-991e7781dc08"}

export const SCIENTIST = {name: "Scientist", description: ["Eager to support a leader with a compelling vision",
                                 "Fiercely loyal with a willingness to follow orders",
                                 "Strong sense of ownership and willing to take the hit for their leader",
                                 "Loves knowing that others depend on their specific contribution",
                                 "Loves data and wants to be the person with the answers",
                                 "Potential to be taken advantage of as a result of extreme loyalty",
                                 "Insecurity may really dampen potential for upward movement",
                                 "Ties self-worth to the notion that others need them"], 
                                 id: "2d81d04e-73f1-4015-7f15-bcb44a70dc08", 
                                 tagId: "afccb468-8dd0-4ef2-fd0e-9c1e7781dc08"}

export const CONSULTANT = {name: "Consultant", description: ["Strong sense of self but still concious of others perspective",
                                       "Adaptable and highly collaborative across teams",
                                       "Hyper-aware of public perception",
                                       "Self-promoters who are constantly trying to prove their worth",
                                       "Fears not having the answers or being overlooked",
                                       "Confident within their expertise but uncomfortable in new situations"], 
                                       id: "f3a163af-d26d-4a42-77da-2ede2179dc08", 
                                       tagId: "c5408ebc-d24e-4c52-f522-9c1e7781dc08"}


export const CAPTAIN = {name: "Captain", description: ["Comfortable working in a team environment to reach metric-driven goals",
                                 "High achiever, thinks in terms of wins and losses",
                                 "Comfortable playing a role or encouraging others to pull their weight",
                                 "Displays leadership through actions more than words",
                                 "Relies on logic and hard work to persuade others",
                                 "Driven by “the right thing to do” for all",
                                 "Fears becoming part of a system that is counter to personal values"], 
                                 id: "fa02a5fe-ac48-48bf-397b-2cde2179dc08", 
                                 tagId: "21c0b5d8-5a82-4452-f522-9c1e7781dc08"}

export const CHAMPION = {name: "Champion", description: ["Active listener but quick to make suggestions",
                                  "Fiercely loyal and will support friends or colleagues at all costs",
                                  "Great at pulling people together to rally behind a cause",
                                  "Low ego coupled with high empathy makes this person vulnerable to manipulation",
                                  "Likely compensating for deep insecurity by hiding behind subject area expertise",
                                  "Fearful of what the future holds if their team is not in control",
                                  "Loyalty to their cause may inhibit ability to effectively judge character"], 
                                  id: "a7508f64-05eb-4b27-7f15-bcb44a70dc08", 
                                  tagId: "f9438358-980d-4192-f522-9c1e7781dc08"}

export const COUNSELOR = {name: "Counselor", description: ["Soft-spoken and adaptable to any given environment",
                                     "Loves having a distinct role within a larger team",
                                     "Earns trust quickly through simple effective communication style",
                                     "Creative problem solver with an ability to be truly objective",
                                     "Interest in solving conflict may leave all parties dissatisfied leading to isolation",
                                     "Fears conflict that they cannot peacefully manage"], 
                                     id: "9b4cb239-8f4f-469a-7f15-bcb44a70dc08",
                                     tagId: "abf3fc64-15ff-43a5-f522-9c1e7781dc08"}

export const SCHOLAR = {name: "Scholar", description: ["Seeks the comradery and safety of a team",
                                   "Looks for ways to stand out and add value to the team",
                                   "Quick to support others and lend a hand",
                                   "Never the first to take action, always observes first",
                                   "Believes in creating value through honorable action",
                                   "Fearful of appearing too ambitious or individualistic"], 
                                   id: "2eafc0a2-1d04-45a1-1118-daec2179dc08", 
                                   tagId: "8e748771-9cac-4047-2e40-971e7781dc08"}

export const PROMOTER = {name: "Promoter", description: ["Highly adaptable between different cultures and environments",
                                     "Fears not having authentic connections or being in touch with themselves",
                                     "Capable of manipulation if it helps the cause",
                                     "Good at blending into a crowd while still making an impact",
                                     "Likes to know the mission but have creativity in how they implement",
                                     "Willing to subvert their own interests and well being for the cause"], 
                                     id: "c912d0a3-6096-48a5-1118-daec2179dc08", 
                                     tagId: "398897da-cefc-4a7e-2e40-971e7781dc08"}

export const PLAYMAKER = {name: "Playmaker", description: ["Obsessed with keeping score and winning",
                                 "Leans into conflict and loves competition",
                                 "Fiery intensity and boundless energy",
                                 "Will break the rules if they think they can get away with it",
                                 "Insatiable need for more, can come at great personal cost",
                                 "Ties self-worth to winning and financial success"], 
                                 id: "58fb55e6-9c3f-476c-ba32-c5f22179dc08", 
                                 tagId: "826202fe-e0d5-47b0-2e40-971e7781dc08"}

export const STRIVER = {name: "Striver", description: ["Outwardly confident and driven to win",
                                   "Dislikes rules and is always willing to challenge the status quo",
                                   "Embraces competition to stay interested",
                                   "Fears failure or being viewed as insignificant",
                                   "Appreciates and pursues aesthetic ideals",
                                   "Always on the go and always over scheduled"], 
                                   id: "fe0dab30-5478-47d0-5dcd-c3f72179dc08", 
                                   tagId: "c7f1ed74-176a-4ff7-f9c2-991e7781dc08"}

export const NEGOTIATOR = {name: "Negotiator", description: ["Will rally to hit numbers when called upon",
                                     "Loves adventure and the thrill of competition",
                                     "Demonstrates poise under pressure",
                                     "Communicates directly and persuasively",
                                     "Biggest fear is failing to achieve goals and real happiness",
                                     "Logical thinkers with an optimistic view of the future",
                                     "Needs clear goals and a playbook on how to achieve them"], 
                                     id: "6307f52d-f7f7-4ae7-206b-1dfd2179dc08", 
                                     tagId: "5fada88e-64ad-4bb0-a1a8-8d1e7781dc08"}

export const STRATEGIST = {name: "Strategist", description: ["Desire to be on the winning side always",
                               "Us versus them mentality, very loyal",
                               "Analyzes multiple outcomes to determine next steps",
                               "Always looking for ways to improve financial standing",
                               "Will lose interest in efforts that are not metric driven",
                               "Tendency toward analytical work but loves to be part of the action",
                               "Risk aversion can lead to feeling like they never reach their potential"], 
                               id: "08bf6d75-df23-4dac-7f67-c4012279dc08", 
                               tagId: "09666963-c06d-4abf-9c06-901e7781dc08"}

export const INTERPRETER = {name: "Interpreter", description: ["Ambitious and willing to hustle to advance themselves",
                             "Will take on different personalities to build relationships",
                             "Strongest driving force is ability to advance",
                             "Fears being deemed obsolete by those in power",
                             "The consumate outside insider - never feels fully in or out",
                             "May struggle to collaborate if they don't see where they can benefit"], 
                             id: "538e8817-e81c-4639-46ad-e90e2279dc08", 
                             tagId: "a3691150-bbcb-45f5-35ce-c6287781dc08"}

export const CHAMELEON = {name: "Chameleon", description: ["Near term focus clouds long term planning",
                             "Constantly seeking acceptance from others",
                             "Highly impressionable but adapts well in different environments",
                             "Tendency toward complacency creates longing for variety",
                             "Likable personality that is quick to support when called upon",
                             "May need time and experience to fully grasp what they want"], 
                             id: "553e2b53-38cd-4298-46ad-e90e2279dc08", 
                             tagId: "36d3614d-09a6-4e91-35ce-c6287781dc08"}

export const MERCENARY = {name: "Mercenary", description: ["Needs clear goals and a playbook on how to achieve them",
                                    "Ambitious and willing to hustle to advance themselves",
                                    "Will take on different personalities to build relationships",
                                    "Constantly seeking to be valued by others",
                                    "Loves a list of tasks they can crush",
                                    "Not afraid to do the dirty work or be the villain",
                                    "Likes to be recognized for their performance and respected for contribution"], 
                                    id: "4c527c7c-8765-40eb-8a9c-bdb44a70dc08", 
                                    tagId: "df89309c-761c-4ba4-402c-c9287781dc08"}